import { UserContextProps } from "@/contexts/UserContext/types";
import { I_PaymentPage, I_PrincingPage } from "@/data/types/pages";
import { PlanProps } from "@/types/plan";
import { RichtextItem, SubscriptionPlan } from "@/types/types";

export interface CouponProps {
  code: string;
  isValid: boolean;
  errorMessage?: string;
}
export interface ISubscriptionPlansContainer {
  data: I_PrincingPage;
  plans: PlanProps[];
  coupon?: CouponProps;
  userIp?: string;
  paymentTexts?: I_PaymentPage;
}

export interface IPlansManager {
  data: I_PrincingPage;
  currentPlan: SubscriptionPlan;
  userContext: UserContextProps;
  coupon?: CouponProps;
  isMounted?: boolean;
  userIp?: string;
}

export const CANCELLED_SUBSCRIPTION = "cancelledSubscription";
export interface PlansContainerProps {
  data: I_PrincingPage;
  currentPlan: SubscriptionPlan;
  onSelectPlan: (planId: string) => void;
  isStatusActive: boolean;
}
export interface PlanWrapperProps extends PlansContainerProps {
  customClass?: string;
  isUserLogged?: boolean;
}

export interface PlanPriceProps {
  price: {
    richtext: RichtextItem | RichtextItem[];
  };
  priceWithDiscount?: string;
}

export interface PlanHeaderProps {
  id: string;
  name: {
    richtext: RichtextItem;
    chip?: string;
  };
  isActive: boolean;
  isStatusActive: boolean;
}

export type SubscriptionPlansNotLoggedProps = PlansContainerProps;

export type SubscriptionPlansLoggedProps = PlansContainerProps;

export type PricingLoggedContainerProps = PlansContainerProps;

export type PricingContainerProps = PlansContainerProps;
